
import React from "react";

// import 'https://customtechnologies.biz/home/css/home_app.css?v=1.2';
import '../styles.scss';
import './section6.scss';

/**
 * Section 6
 * footer
 */

const Section6: React.FC = () => {

	const year = new Date().getFullYear();

	const getISTTime = () => {
		return new Date().toLocaleString("en-IN", {
			timeZone: "Asia/Kolkata",
			weekday: "long",
			hour: "2-digit",
			minute: "2-digit",
		});
	};


	return (
		<>
			<footer>
				<div className="container">
					<div className="col-footer">
						<img src="https://customtechnologies.biz/home/images/footer-icon.gif" title="rotobics-footer" alt="rotobics custom technologies" className="footer-logo" />
					</div>
					<div className="col-footer">
						<div className="align-center qlink">
							<h3 className="h3_ql">quick links</h3>
							<p><a className="qpara" href="https://customtechnologies.biz/home/" target="_blank">Home</a></p>
							<p><a className="qpara" href="https://customtechnologies.biz/home/projects.html" target="_blank">Projects</a></p>
							<p><a className="qpara" href="https://customtechnologies.biz/home/verticals.html?direct&_v=vertical-immersive_space" target="_blank">Immersive spaces</a></p>
							<p><a className="qpara" href="https://customtechnologies.biz/home/verticals.html?direct&_v=vertical-lifescience" target="_blank">LifeSciences</a></p>
							<p><a className="qpara" href="https://customtechnologies.biz/home/verticals.html?direct&_v=vertical-brandnretail" target="_blank">Brand and Retail</a></p>
							<p><a className="qpara" href="https://customtechnologies.biz/home/verticals.html?direct&_v=vertical-xr" target="_blank">XR</a></p>
							<p><a className="qpara" href="https://customtechnologies.biz/home/creative-technologies.html" target="_blank">Creative Technologists</a></p>
							<p><a className="qpara" href="https://customtechnologies.biz/home/ct_ed_hub/" target="_blank">Ed Hub</a></p>
							<p><a className="qpara" href="https://customtechnologies.biz/home/blogs/" target="_blank">Blogs</a></p>


						</div>
					</div>
					<div className="col-footer">
						<div className="align-center">
							<h3>let’s talk</h3>

							<p>
								<a href="mailto:sameer@customtechnologies.biz">
									sameer@customtechnologies.biz
								</a>
							</p>

							<p>
								<a href="tel:919892951244">+91-9892951244</a>
							</p>

							{/* Mumbai */}
							<p className="munbai-based">Mumbai</p>
							<p className="loc-head-based">
								Design Headquarters<br />
								Our creative nerve center where immersive ideas take shape.
							</p>
							<p className="ct_addr">
								301-305-306, Sheetal Enclave, Near Knox Plaza, Mindspace, Malad
								West, Mumbai – 400064
							</p>

							{/* Brussels */}
							<p className="munbai-based">Brussels</p>
							<p className="loc-head-based">
								European Collaborations Node<br />
								A strategic anchor for building global partnerships and shaping
								cross-border experiences.
							</p>
							<p className="ct_addr">
								Chaussée de Charleroi 110, 1060 Saint-Gilles, Brussels
							</p>

							{/* Delhi */}
							<p className="munbai-based">Delhi</p>
							<p className="loc-head-based">
								Strategic Alliances<br />
								The base for our global partnerships and market outreach, where
								vision meets velocity.
							</p>

							<div className="current-time">
								IST LOCAL TIME: <span className="curTime">{new Date().toLocaleString("en-IN", {
									timeZone: "Asia/Kolkata",
									weekday: "long",
									hour: "2-digit",
									minute: "2-digit",
									hour12: true,
								})}</span>
							</div>

						</div>
					</div>

					<div className="col-footer social-links">
						<ul>
							<li>
								<a
									href="https://www.instagram.com/customtechnologiesdesignlab/"
									target="_blank"
									rel="noopener noreferrer"
								>
									In.
								</a>
							</li>
							<li>
								<a
									href="https://www.facebook.com/customtechnologies.biz"
									target="_blank"
									rel="noopener noreferrer"
								>
									Fb.
								</a>
							</li>
							<li>
								<a
									href="https://www.linkedin.com/company/customtechlabs"
									target="_blank"
									rel="noopener noreferrer"
								>
									Li.
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div className="copyright">
					<p>©{year} CustomTechnologies Design Lab Pvt. Ltd. All Rights Reserved.</p>
				</div>
			</footer>

		</>)
}

export default Section6;

